import { z } from "zod";

// Channels an event can originate from.
export const eventSourceSchema = z.enum([
  "qr",
  "manual",
  "voice",
  "photo",
  "email",
  "web",
  "system",
  "stripe",
  "seed",
]);
export type EventSource = z.infer<typeof eventSourceSchema>;

// Aggregate (entity) types tracked by the log.
export const aggregateTypeSchema = z.enum([
  "sign_in",
  "recording",
  "worker_certificate",
  "form",
  "worker_approval",
  "site_manager",
  "notification",
  "inbound_email",
  "subscription",
  "data_subject",
  "site",
  "billing_account",
  "user_permission",
  "daily_report",
]);
export type AggregateType = z.infer<typeof aggregateTypeSchema>;

// Metadata the event store needs alongside a typed payload. `seq`, `recordedAt`
// and `version` are assigned by the store, not the caller.
export const eventEnvelopeSchema = z.object({
  aggregateType: aggregateTypeSchema,
  aggregateId: z.string().min(1),
  source: eventSourceSchema,
  occurredAt: z.date(),
  orgId: z.string().nullable().optional(),
  siteId: z.string().nullable().optional(),
  actorUserId: z.string().nullable().optional(),
  subjectUserId: z.string().nullable().optional(),
  dedupeKey: z.string().min(1).nullable().optional(),
});
export type EventEnvelope = z.infer<typeof eventEnvelopeSchema>;
